import React, { Component } from "react";
import { ClipLoader } from "react-spinners";

const bgColors = {
  default: "#81b71a",
  blue: "#00B1E1",
  cyan: "#37BC9B",
  green: "#8CC152",
  red: "#E9573F",
  yellow: "#F6BB42",
};

class LoadingScreen extends Component {
  seconds = 0;
  constructor(props) {
    super(props);
    this.state = { bgColor: "#00BFFF", tooLong: "" };
    this.interval = setInterval(() => {
      let tooLong = "";
      let randomColor =
        bgColors[
          Object.keys(bgColors)[
            Math.floor(Math.random() * Object.keys(bgColors).length)
          ]
        ];
      this.seconds++;
      if (this.seconds > 10)
        tooLong = "Loading seems taking longer than expected...";
      if (this.seconds > 20)
        tooLong = "Loading is too long. Consider refreshing.";
      this.setState(() => ({ bgColor: randomColor, tooLong: tooLong }));
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div
        style={{ 
          minHeight: "100vh", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center",
          textAlign: "center",
          backgroundColor: "#ffffffff"
        }}
      >
        <div>
          <ClipLoader
            color="#2997ff" // Match the blue theme
            loading={true}
            cssOverride={{ display: "block", margin: "0 auto" }}
            size={80}
          />
          <br />
          <div style={{ color: "white", marginTop: "20px", fontSize: "14px" }}>
            {this.state.tooLong}
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingScreen;
